import { Box } from "@chakra-ui/react";
import { ColorIcon, colors, customEvent, HStack, VLine } from "goi_common";
import { useRouter } from "next/router";

export const ParlorEstimateCard = ({
  type,
  item,
  hasLink = true,
  path = "parlor_detail",
}: {
  type: "answered" | "waiting";
  item: any;
  hasLink?: boolean;
  path?: "parlor_detail";
}) => {
  const router = useRouter();
  return (
    <HStack
      borderRadius="10px"
      background={colors.white}
      boxShadow="0px 0px 12px 0px rgba(0, 0, 0, 0.06)"
      width="100%"
      alignItems="center"
      justifyContent="space-between"
      padding="12px"
      onClick={() => {
        if (hasLink) {
          customEvent({
            newGtm: {
              path,
              trigger_and_target: `estimate_card_${String(item.id)}-uv_match_request`,
            },
          });
          router.push("/match/request/");
        }
      }}
    >
      <HStack alignItems="center" justifyContent="flex-start">
        {hasLink && (
          <>
            <Box
              textAlign="center"
              className="body_14_m gray500"
              padding="0 12px 0 0"
              minWidth="fit-content"
            >
              실시간
              <br />
              견적
            </Box>
            <VLine width="1px" height="40px" color={colors.gray300} />
          </>
        )}
        <Box
          padding="0 0 0 12px"
          className={`subtitle_14_sb`}
          color={`${type === "answered" ? colors.blue950 : colors.warmGray800}`}
        >
          <b>{item.name}</b> | <span className="body_14_m">{item.tag}</span>
          <br />
          <Box
            display="flex"
            gap={1}
            className="subtitle_14_sb"
            color={type === "answered" ? colors.blue650 : colors.warmGray800}
            css={{
              WebkitLineClamp: 1,
              WebkitBoxOrient: "vertical",
            }}
          >
            <span
              style={{
                width: "60px",
                minWidth: "60px",
              }}
            >
              [{type === "answered" ? "견적완료" : "견적대기"}]
            </span>
            <Box
              as="span"
              color={type === "answered" ? colors.blue800 : colors.warmGray650}
              textOverflow="ellipsis"
              overflow="hidden"
              display="-webkit-box"
              maxHeight="24px"
              css={{
                WebkitLineClamp: 1,
                WebkitBoxOrient: "vertical",
              }}
            >
              {" "}
              {item.suggestion}
            </Box>
          </Box>
        </Box>
      </HStack>
      {hasLink && <ColorIcon name="arrow_right_small" color={colors.gray600} size={16} />}
    </HStack>
  );
};
